<div class="not-found-wrapper" fxLayout="column" fxLayoutAlign="center center">

  <h1>404 {{'PAGE_NOT_FOUND' | translate}}</h1>
  <p>{{'PAGE_DOES_NOT_EXIST' | translate}}</p>
  <a [routerLink]="'/'">{{'GO_BACK_HOME' | translate}}</a>

</div>
